import React, { Component } from "react";
import packageInfo  from '../package.json';
import CacheBuster from 'react-cache-buster';
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Switch } from "react-router-dom";
import { withMsal } from "@azure/msal-react";
import { setNewRoute } from "./store/actions/alerts-actions";
import { getB2CLoginUrl } from "./authConfig";
import { msalInstance } from "./index";
import { DomainContext } from "./store/DomainContext";

import {
  checkCanUserEdit,
  updateUserAccountInfo
} from "./modules/common/util/AccountsUtil";
import { bindActionCreators } from "redux";
import { setLoginState, setReturnURL } from "./store/actions/login-actions";
import SessionExpiryModalDialog from "./modules/common/session-expired/SessionExpired";
import { logOut } from "./store/actions/login-actions";
// import
import HomePage from "./modules/home/HomePage";
import ViewYourProfile from "./modules/view-profile/ViewProfile";
import LoginPage from "./modules/login/LoginPage";
import ResetPasswordPage from "./modules/reset-password/ResetPasswordPage";
import FormStyles from "./modules/common/form-fields/FormStyles";
import AuthenticatedRoute from "./routes/AuthenticatedRoute";
import PublicRoute from "./routes/PublicRoute";
import MobileAppRoute from "./routes/MobileAppRoute";
import UpdatePassword from "./modules/account/update-password/UpdatePassword";
import FileClaim from "./modules/claims/file-claim/FileClaim";
import UpdateBilling from "./modules/account/update-billing/UpdateBilling";
import MobileAppUpdateBilling from "./modules/account/update-billing/MobileAppUpdateBilling";
import ViewClaimStatus from "./modules/claims/claim-status/ViewClaimStatus";
import UploadMissingDocs from "./modules/claims/upload-missing-docs/UploadMissingDocs";
import UpdateReimbursement from "./modules/account/update-reimbursement/UpdateReimbursement";
import AnniversaryCoverageOptions from "./modules/pet-policies/anniversary-coverage-options/AnniversaryCoverageOptions";
import UpdateProfile from "./modules/account/update-profile/UpdateProfile";
import AddPet from "./modules/pet-policies/add-pet/AddPet";
import MobileAppAddPet from "./modules/pet-policies/add-pet/MobileAppAddPet";
import ChangePolicy from "./modules/pet-policies/change-policy-options/ChangePolicy";
//import PostponePayment from "./modules/postpone-payment/PostponePayment";
import UploadMedicalRecords from "./modules/claims/upload-medical-records/UploadMedicalRecords";
import OopsLostPage from "./modules/oops/OopsLostPage";
import GetMobileApp from "./modules/get-mobile-app/GetMobileApp";
import FAQ from "./modules/faq/faq";
import PolicyDocs from "./modules/policy-docs/PolicyDocs";
import SalesForceLink from "./modules/common/salesForceLink/SalesForceLink";
import Contact from "./modules/contact/contact";
import Reinstatement from "./modules/reinstatement/reinstatement";
import PetDetails from "./modules/pet-details/PetDetails";
import ChangeAddress from "./modules/change-address/ChangeAddress";
import ChangeMailingAddress from "./modules/change-mailing-address/ChangeMailingAddress";
import RaFTermsConditions from "./modules/terms-conditions/RaFTermsConditions";
import CancelPolicy from "./modules/cancel-policy/cancel-policy";
import PostCancelPolicy from "./modules/post-cancel-policy/PostCancelPolicy";
import RetryBillingSuccess from "./modules/account/retry-billing/RetryBillingSuccess";
import NewMailingAddress from "./modules/change-mailing-address/UpdateMailingAddress";
import CCTLogin from "./modules/cct-login/CCTLogin";
import EOBLink from './modules/common/salesForceLink/EOBLink';
import ARNLink from './modules/common/salesForceLink/ARNLink';
import SalesForceContentLink from "./modules/common/salesForceLink/SalesForceContentLink";
import { AppLinks, PageTitles } from "./constants/app-links";
import { MsalContext } from "@azure/msal-react";
import Loader from "./modules/common/loader/Loader";

import { getCredentialsIfValid, saveCredentials } from "./api/auth/auth";
import { validateSession, decryptOAuthToken } from "./api/auth-api";
import { getAccountInfo } from "./api/accounts-api";

import "./App.css";
import { PublicClientApplication, InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalConfig } from "./authConfig";




//const msalInstance = new PublicClientApplication(msalConfig);
const resolveRedirectTarget = (savedRedirect) => {
  if (!savedRedirect) return savedRedirect;
  try {
    const url = new URL(savedRedirect, window.location.origin);
    const pathLower = url.pathname.toLowerCase();
    if (pathLower === "/login" || pathLower === "/login/") {
      const returnUrlParam =
        url.searchParams.get("ReturnUrl") ||
        url.searchParams.get("returnUrl") ||
        url.searchParams.get("returnurl");
      if (returnUrlParam) {
        const decoded = decodeURIComponent(returnUrlParam);
        return decoded.startsWith("/") ? decoded : "/" + decoded;
      }
    }
  } catch (e) {
    //fall through and return the original string
  }
  return savedRedirect;
};

//console.log("Tab check");
// // Run once when app loads
// const isTabOpen = sessionStorage.getItem("tabActive");

// if (!isTabOpen) {
//   const accounts = msalInstance.getAllAccounts();
//   accounts.forEach((account) => {
//     msalInstance.getTokenCache().removeAccount(account);
//   });

//   sessionStorage.clear();
// }

// // Mark tab active
// sessionStorage.setItem("tabActive", "true");

// // Remove flag on tab close
// window.addEventListener("beforeunload", () => {
//   sessionStorage.removeItem("tabActive");
// });

class App extends Component {
  state = {
    displayTopBanner:false
  }
  state = {
    baseDomain: null
  };
  disableAlertCreated = false;
  static contextType = MsalContext;
   
  //We are setting location for alerts, which are not matching with actual routes
  //[Alternate] We can change the route itself, but it will cause rerendering of the route component
  //This way only route component is rerender
  // We need to set different location for step1 of below routes by calling setNewRoute action in respective component
  setLocationForAlert = () => {
    const pathName = this.props.location.pathname.toLocaleLowerCase();
    if (pathName) {
      if (PageTitles[pathName]) document.title = PageTitles[pathName];
      else document.title = PageTitles["default"];
    } else {
      document.title = PageTitles["default"];
    }

    switch (pathName) {
      case "/mobileappaddpet":
        this.props.actions.setNewRoute("/MobileAppAddPet/Step1");
        return;
      case "/addpet":
        this.props.actions.setNewRoute("/AddPet/Step1");
        return;
      case "/changepolicyoptions":
        this.props.actions.setNewRoute("/ChangePolicyOptions/Step1");
        return;
      //case "/postponepayment":
      //  this.props.actions.setNewRoute("/PostponePayment/Step1");
      //  return;
      case "/cancelpolicy":
        this.props.actions.setNewRoute("/CancelPolicy/Step1");
        return;
      default:
        this.props.actions.setNewRoute(this.props.location.pathname);
    }
  };
  
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      this.setLocationForAlert();
      if (this.props.userDetails) {
        //Checks for billing day and login time
        //Disable some features if the login time falls on Sales Force script run time
        checkCanUserEdit(this.props.userDetails.BillingDay);
      }
    }
  }

  async componentDidMount() {
     // Check if value exists in localStorage (first load only)
    let domain = localStorage.getItem("baseDomain");

    if (!domain) {
      // Extract base domain from current URL
      const decoded = decodeURIComponent(window.location.href);
      const match = decoded.match(/https:\/\/[^ ]+/);

      if (match) {
        domain = new URL(match[0]).hostname;
        localStorage.setItem("baseDomain", domain); // persist it
      }
    }

    // Set state once
    this.setState({ baseDomain: domain });
    let authToken = '';
    // console.log("did mountr called");
    // console.log("Using direct MSAL instance");

    // console.log("Forgot password link");
    let tempUrl=window.location.href;

    // Detect mobile app routes that pass authentication via querystring token
    const mobileAppPaths = [
      "/mobileappupdatebillinginfo",
      "/mobileappaddpet",
      "/updateaddressmobile",
      "/eob/",
      "/mobileeob/",
      "/arn/"
    ];
    const lowerUrl = tempUrl.toLowerCase();
    const isMobileAppRoute = mobileAppPaths.some(p => lowerUrl.includes(p));
    const urlParams = new URLSearchParams(window.location.search || window.location.hash.replace('#', '?'));
    const queryToken = urlParams.get("token") || urlParams.get("id_token");
    const isMobileAppWithToken = isMobileAppRoute && queryToken;
    
    if (isMobileAppWithToken) {
      authToken = queryToken;
      // Skip the entire MSAL flow — jump directly to the token validation logic
    }

    if(tempUrl.includes("login?page=forgot") || tempUrl.includes("?page=create")){
      console.log(window.location.href);
    }

    if (!isMobileAppWithToken) {
      //  STEP 1: Process redirect response FIRST
      let redirectResponse = null;
      try {
        redirectResponse = await msalInstance.handleRedirectPromise();
      } catch (e) {
        console.warn("MSAL handleRedirectPromise error:", e);
      }

      if (redirectResponse) {
        //console.log(" Redirect handled");
        msalInstance.setActiveAccount(redirectResponse.account);
      }
  
      //  STEP 2: Now check accounts
      const accounts = msalInstance.getAllAccounts(); 
      //console.log(accounts);

      if (!(tempUrl.includes("resetpassword?token=") || tempUrl.includes("login?page=forgot") || tempUrl.includes("?page=create")) && accounts.length === 0) {
        //console.log(" No account → redirecting to B2C");
        const currentPath = window.location.pathname + window.location.search;
        if (currentPath && currentPath !== "/" && currentPath !== "/login") {
          sessionStorage.setItem("redirect", currentPath);
        }
        await msalInstance.loginRedirect({
          scopes: ["openid", "profile", "offline_access"]
        });
        return;
      }
      

      let response='';
      
      if (!(tempUrl.includes("resetpassword?") || tempUrl.includes("login?page=forgot") || tempUrl.includes("?page=create")))
      {
        //  STEP 3: Set active account
        msalInstance.setActiveAccount(accounts[0]); 
        //  STEP 4: Acquire token
        try {
          response = await msalInstance.acquireTokenSilent({
            scopes: ["openid", "profile", "offline_access"],
            account: accounts[0]
          });
          authToken = response.idToken;
          console.log(response);
          // debugger;
          //console.log(" after setlogin");
        } catch (tokenError) {
          if (tokenError instanceof InteractionRequiredAuthError) {
            console.warn("Silent token refresh failed, redirecting to B2C:", tokenError);
            sessionStorage.setItem("redirect", window.location.pathname + window.location.search);

            await msalInstance.loginRedirect({
              scopes: ["openid", "profile", "offline_access"]
            });
            return;
          }
          console.error("acquireTokenSilent failed:", tokenError);
          this.props.actions.setLoginState(false);
          return;
        }
      }
    }

    var affId = window.location.search.toLowerCase().includes("affid") ? new URLSearchParams(window.location.search).get("affid") : "";

    if(affId.length > 0)
    {
      sessionStorage.setItem("affId",affId);
    }
    
    try {

      /* ---------- BroadcastChannel hydration bootstrap (sync selected session keys) ---------- */
      const SYNC_KEYS = [
          'affId',
          'firstTimeVisit',
          'secondVisit',
          'auth-token',
          'token',
          'totalUser',
          'users',
          'expiresOn'
      ];

      const readSelected = () => {
          const data = {};
          let hasAny = false;
          for (const k of SYNC_KEYS) {
              const v = sessionStorage.getItem(k);
              if (v !== null) {
                  data[k] = v;
                  hasAny = true;
              }
          }
          return hasAny ? data : null;
      };

      const mergeIntoSession = (incoming, { onlyIfMissing = true } = {}) => {
        if (!incoming || typeof incoming !== 'object') return;
        for (const [k, v] of Object.entries(incoming)) {
          if (!SYNC_KEYS.includes(k)) continue;
          if (v === null || typeof v === 'undefined') continue;
          if (onlyIfMissing) {
            if (sessionStorage.getItem(k) === null) {
                sessionStorage.setItem(k, v);
            }
          } else {
            sessionStorage.setItem(k, v);
          }
        }
      };

      const haveMissing = () => {
        // if any of the keys is missing, we�ll try to hydrate
        return SYNC_KEYS.some((k) => sessionStorage.getItem(k) === null);
      };

      this.bc = null;
      if (typeof window !== 'undefined' && 'BroadcastChannel' in window) {
          this.bc = new BroadcastChannel('session-auth-v1');

          this.bc.onmessage = (e) => {
              const msg = e.data;
              if (!msg || typeof msg !== 'object') return;

              if (msg.type === 'REQUEST_AUTH_DATA') {
                  const payload = readSelected();
                  if (payload) {
                      this.bc.postMessage({ type: 'AUTH_DATA', data: payload });
                  }
              } else if (msg.type === 'AUTH_DATA' && msg.data) {
                  // hydrate ONLY missing values to avoid clobbering fresh writes during boot
                  mergeIntoSession(msg.data, { onlyIfMissing: true });
              }
          };

          // Ask others immediately if we have any missing key
          if (haveMissing()) {
              this.bc.postMessage({ type: 'REQUEST_AUTH_DATA' });
              // Give other tabs a short moment to respond before your auth check
              await new Promise((r) => setTimeout(r, 300));
          }

          // If we have anything locally, proactively broadcast once for late joiners
          const payload = readSelected();
          if (payload) {
              this.bc.postMessage({ type: 'AUTH_DATA', data: payload });
          }
      }


      // Fetch URL Parameter
      //This is check for Return URL query param
      var input = this.props.location.search.trim().replace(/^[?#&]/, "");
      if(!input)
      {
         input = this.props.location.hash.trim().replace('#', "");
      }
      if (
        this.props.location &&
        this.props.location.pathname &&
        //this.props.location.pathname.toLowerCase() === "/login" &&
        this.props.location.search
      ) {
        for (const param of input.split("&")) {
          let [key, value] = param.split("=");
          if (key && key.toLowerCase() === "returnurl") {
            this.props.actions.setReturnURL(true);
            this.props.history.push(value);
          }
        }
      }
      
      
      // debugger;
      // if an auth-token is passed, get the related credentials from the service and store them if available
      if (authToken) {
        sessionStorage.setItem("auth-token", authToken);
        let decodedTokenResponse = await decryptOAuthToken(authToken);
        // console.log("decryptOAuthToken response:", decodedTokenResponse);
        // console.log("expires_in:", decodedTokenResponse?.expires_in);
        // console.log("access_token:", decodedTokenResponse?.access_token);

        let username = decodedTokenResponse.user_name
          || (decodedTokenResponse && decodedTokenResponse.idTokenClaims && decodedTokenResponse.idTokenClaims.signInName)
          || (decodedTokenResponse && decodedTokenResponse.account && decodedTokenResponse.account.username)
          || null;
        //console.log("username:", username);

        if (!username) {
          console.error("Could not determine username from token response");
          this.props.actions.setLoginState(false);
          return;  // or skip to the end of the try block
        }

        let credentials = {
          username: username,
          password: '',
          rememberMe: '',
        };
        //console.log("credentials:", credentials);
        
        if (window.location.hash || window.location.search) {
          // Option A: Keep existing path
          const cleanPath = window.location.pathname;
          
          // Option B: If you want to keep SOME params but remove others, 
          // you'd use URLSearchParams here.
          
          window.history.replaceState(null, '', cleanPath);
        }
        saveCredentials(credentials, decodedTokenResponse);
      }
      

      // Check is credentials are available.
      let credentials = getCredentialsIfValid();
      if (credentials) {
        validateSession(credentials)
          .then(() => {
            getAccountInfo()
              .then(accountResponse => {
                if (accountResponse) {
                  updateUserAccountInfo(accountResponse);
                  this.props.actions.setLoginState(true);

                  const savedRedirect = sessionStorage.getItem("redirect");
                  if (savedRedirect && savedRedirect !== "/" && savedRedirect !== "/login") {
                    sessionStorage.removeItem("redirect");
                    this.props.history.push(resolveRedirectTarget(savedRedirect));
                  }
                } else {
                  this.props.actions.setLoginState(false);
                }
              })
              .catch(() => {
                this.props.actions.setLoginState(false);
                window.scrollTo(0, 0);
              });
          })
          .catch(error => {
            this.props.actions.setLoginState(false);
            window.scrollTo(0, 0);
          });
      } else if (authToken) {
        // We have a valid MSAL token but getCredentialsIfValid failed.
        // Try validateSession using the username from the decoded token directly.
        let decodedUsername = sessionStorage.getItem("users");
        let fallbackCredentials = null;
        if (decodedUsername) {
          try {
            let parsed = JSON.parse(decodedUsername);
            let uname = Array.isArray(parsed) ? parsed[0].username : parsed.username;
            if (uname) {
              fallbackCredentials = { username: uname };
            }
          } catch(e) { /* ignore parse errors */ }
        }
        if (fallbackCredentials) {
          validateSession(fallbackCredentials)
            .then(() => {
              getAccountInfo()
                .then(accountResponse => {
                  if (accountResponse) {
                    updateUserAccountInfo(accountResponse);
                    this.props.actions.setLoginState(true);

                    const savedRedirect = sessionStorage.getItem("redirect");
                    if (savedRedirect && savedRedirect !== "/" && savedRedirect !== "/login") {
                      sessionStorage.removeItem("redirect");
                      this.props.history.push(resolveRedirectTarget(savedRedirect));
                    }
                  } else {
                    this.props.actions.setLoginState(false);
                  }
                })
                .catch(() => {
                  this.props.actions.setLoginState(false);
                  window.scrollTo(0, 0);
                });
            })
            .catch(error => {
              this.props.actions.setLoginState(false);
              window.scrollTo(0, 0);
            });
        } else {
          this.props.actions.setLoginState(false);
        }
      } else {
        this.props.actions.setLoginState(false);
      }

    } catch (error) {
      this.props.actions.setLoginState(false);
    }
  }

  toggleSessionExpiryModal = () => {
    this.props.actions.logOut();
  };

  render() {
    return (
      <CacheBuster
        currentVersion={packageInfo.version}
        isEnabled={true} //If false, the library is disabled.
        isVerboseMode={false} //If true, the library writes verbose logs to console.
        metaFileDirectory={'.'} //If public assets are hosted somewhere other than root on your server.
      >
      <div>
        
        <SessionExpiryModalDialog
          toggleSessionExpiryModal={this.toggleSessionExpiryModal}
          showSessionExpiryModal={this.props.loginExpired}
        />

        {this.props.loggedIn !== null || window.location.href.includes("resetpassword") || window.location.href.includes("login?page=") ? (
          <div>
            <Switch>
              <AuthenticatedRoute
                exact
                path="/"
                loggedIn={this.props.loggedIn}
                component={HomePage}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.account.viewProfile}
                loggedIn={this.props.loggedIn}
                component={ViewYourProfile}
              />
              <PublicRoute
                exact
                path="/forms"
                loggedIn={this.props.loggedIn}
                component={FormStyles}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.account.changeProfile}
                loggedIn={this.props.loggedIn}
                component={UpdateProfile}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.account.changePassword}
                loggedIn={this.props.loggedIn}
                component={UpdatePassword}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.claims.fileClaim}
                loggedIn={this.props.loggedIn}
                component={FileClaim}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.account.updateBillingInfo}
                loggedIn={this.props.loggedIn}
                component={UpdateBilling}
              />
              <MobileAppRoute
                path={AppLinks.policy.mobileAppAddPet}
                loggedIn={this.props.loggedIn}
                component={MobileAppAddPet}
              />
              <MobileAppRoute
                path={AppLinks.account.mobileAppUpdateBillingInfo}
                loggedIn={this.props.loggedIn}
                component={MobileAppUpdateBilling}
              />
              <MobileAppRoute
                path={AppLinks.account.mobileAppChangePhysicalAddress}
                loggedIn={this.props.loggedIn}
                component={ChangeAddress}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.account.changePhysicalAddress}
                loggedIn={this.props.loggedIn}
                component={ChangeAddress}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.claims.claimStatus}
                loggedIn={this.props.loggedIn}
                component={ViewClaimStatus}
              />
              <AuthenticatedRoute
                path={AppLinks.claims.updateClaim}
                loggedIn={this.props.loggedIn}
                component={UploadMissingDocs}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.account.updateReimbursement}
                loggedIn={this.props.loggedIn}
                component={UpdateReimbursement}
              />
              {/* <AuthenticatedRoute
                exact
                path={AppLinks.account.updateMailingAddress}
                loggedIn={this.props.loggedIn}
                component={NewMailingAddress}
              /> */}
              <AuthenticatedRoute
                exact
                path={AppLinks.account.updateMailingAddress}
                loggedIn={this.props.loggedIn}
                component={ChangeMailingAddress}
              /> 
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.anniversaryCoverageOptions}
                loggedIn={this.props.loggedIn}
                component={AnniversaryCoverageOptions}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.claims.uploadMedicalRecords}
                loggedIn={this.props.loggedIn}
                component={UploadMedicalRecords}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.claims.getMobileApp}
                loggedIn={this.props.loggedIn}
                component={GetMobileApp}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.faq.faq}
                loggedIn={this.props.loggedIn}
                component={props => <FAQ time={new Date()} {...props} />}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.others.contact}
                loggedIn={this.props.loggedIn}
                compState = {this.state}
                component={props => <Contact time={new Date()} {...props} />}
              />
              <AuthenticatedRoute
                  exact
                  path={AppLinks.others.reinstatement}
                  loggedIn={this.props.loggedIn}
                  compState={this.state}
                  component={props => <Reinstatement {...props} />}
                />
              <AuthenticatedRoute
                exact
                path={AppLinks.others.RAFTermsAndConditions}
                loggedIn={this.props.loggedIn}
                component={RaFTermsConditions}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.viewPetDetails}
                loggedIn={this.props.loggedIn}
                component={PetDetails}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.viewPolicyDocuments}
                loggedIn={this.props.loggedIn}
                component={PolicyDocs}
              />
              {/*<PublicRoute
                exact
                path={AppLinks.policy.file} 
                component={SalesForceLink}
              />*/}              
              {/* This route works only for EOB file link */}
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.eobFileLink}  
                loggedIn={this.props.loggedIn}              
                component={SalesForceLink}
              />
              <MobileAppRoute
                path={AppLinks.policy.mobileEOBFileLink}
                loggedIn={this.props.loggedIn}
                component={SalesForceLink}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.file}
                loggedIn={this.props.loggedIn}
                component={SalesForceLink}
              />
            
              <AuthenticatedRoute
                path={AppLinks.policy.pubfile}
                loggedIn={this.props.loggedIn}
                component={SalesForceLink}
              />
              {/*<AuthenticatedRoute
                exact
                path={AppLinks.others.eobLink}
                loggedIn={this.props.loggedIn}
                component={EOBLink}
              />*/}
              <PublicRoute
                exact
                path={AppLinks.others.eobLink}
                component={EOBLink}
              />
              <PublicRoute
                path={AppLinks.others.arnLink}
                component={ARNLink}
              />

            <AuthenticatedRoute
              exact
              path={AppLinks.others.contentDocumentLink}     
              loggedIn={this.props.loggedIn}
              userAccountDetails={this.props.userAccountDetails}
              component={SalesForceContentLink}
            />
            {/*<AuthenticatedRoute
                exact
                path={AppLinks.others.postponePayment}
                loggedIn={this.props.loggedIn}
                component={PostponePayment}
              />*/}
              <PublicRoute path={AppLinks.others.resetpassword} component={ResetPasswordPage} />
              <PublicRoute
                path={AppLinks.others.cctlogin}
                component={CCTLogin}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.addPet}
                loggedIn={this.props.loggedIn}
                component={AddPet}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.policy.changePolicyOptions}
                loggedIn={this.props.loggedIn}
                component={ChangePolicy}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.others.cancelPolicy}
                loggedIn={this.props.loggedIn}
                component={CancelPolicy}
              />
              <PublicRoute
                exact
                path={AppLinks.others.postCancelPolicy}
                component={PostCancelPolicy}
              />
              <AuthenticatedRoute
                exact
                path={AppLinks.others.retryBillingSuccess}
                loggedIn={this.props.loggedIn}
                component={RetryBillingSuccess}
              />
              <PublicRoute path={AppLinks.others.login} component={LoginPage} />
              <AuthenticatedRoute
                loggedIn={this.props.loggedIn}
                component={OopsLostPage}
              />
            </Switch>
          </div>
        ) : (
          <Loader position="absolute" />
        )}
      </div>
      </CacheBuster>
    );
  }
}

// Subscribe component to redux store and merge the state into
// component's props
const mapStateToProps = state => ({
  loggedIn: state.login.loggedIn,
  loginExpired: state.login.loginExpired,
  userDetails: state.account.userAccountDetails
});

//Wrap all the actions with dispatcher
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setLoginState,
      logOut,
      setNewRoute,
      setReturnURL
    },
    dispatch
  )
});

export default withRouter(
  withMsal(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(App)
  )
);
